import { DEFAULT_LAYOUT } from 'src/constants/common';

export const ACCOUNT_ORDER_LAYOUT = Object.freeze({
  ...DEFAULT_LAYOUT,
  main: { withNavy050BG: true },
});
export const PUBLIC_ORDER_LAYOUT = Object.freeze({
  ...DEFAULT_LAYOUT,
  header: { template: 'PlainHeader', showSiteLinks: false },
  main: { withNavy050BG: true },
});
export const PAGE_NAME = 'accountOrder';
export const ACCEPT_STAND_BY_TIME = 'accountOrder/ACCEPT_STAND_BY_TIME';
export const DECLINE_STAND_BY_TIMES = 'accountOrder/DECLINE_STAND_BY_TIMES';
export const CANCEL_ORDER = 'accountOrder/CANCEL_ORDER';
export const CANCE_ORDER_SEGMENT_EVENT  = 'accountOrder/CANCE_ORDER_SEGMENT_EVENT';

export const HOURS_BEFORE_APPT = {
  CANCEL_PARTIAL: 24,
  CANCEL_FULL: 3,
  RESCHEDULE_PARTIAL: 3,
  MANUAL_OVERRIDE_NO_FEE: 25,
};

export const FEES = {
  CANCEL_NO_FEE: 'cancelNoFee',
  CANCEL_PARTIAL: 'cancelPartial',
  CANCEL_FULL: 'cancelFull',
  RESCHEDULE_NO_FEE: 'rescheduleNoFee',
  RESCHEDULE_PARTIAL: 'reschedulePartial',
};

export const SNACKBAR_NAME = 'ORDER_PAGE_SNACKBAR';

// TODO: Move this up a level? -GH June 18, 2021
export const SERVICE_ADJUSTMENT_TYPES = {
  /*
    Service Adjustments are adjustments attached to an individual service.

    Service Adjustments do not come through with a type property like the cart, only with a name
    and amount. So instead of filtering by type we need to filter by substring.
  */
  SHP_DISCOUNT: 'subscription discount',
  SUBSIDIZED: 'covered by', // Complete message from server is "Covered by ${partnerName}"
  AUTOMATIC_DISCOUNT: 'automatic discount',
};

export const ORDER_ADJUSTMENT_TYPES = {
  /* Order Adjustments are adjustments applied to the entire order, and not individual service line items */
  TAX: 'tax',
};

export const PANEL_HEADERS = {
  ORDER_DETAILS: 'Order Details',
  PRODUCT_SHIPPING_INFO: 'Shipping Information',
};

export const ORDER_SUMMARY_CARD_ID = 'order-summary-card';

export const STATUS_CARD_TITLES = {
  APPT: 'APPOINTMENT',
  SHIPMENT: 'SHIPMENT',
  REMOTE_SUPPORT: 'REMOTE SUPPORT',
};

export const STATUS_CARD_HEADERS = {
  PENDING: 'Pending',
  CONFIRMED: 'Your appointment has been scheduled!',
  REMOTE_SUPPORT: 'Initiate your virtual service anytime',
  TECH_LATE:
    'Your technician couldn’t make it to the original appointment. Do any of these times work for you?',
  JOB_STARTED: 'Your appointment has started!',
  COMPLETED: 'Your service is completed. Thank you for choosing HelloTech!',
  STAND_BY: 'Do any of these alternate times work for you?',
  RESCHEDULE:
    'We couldn’t find a tech for the times selected. Could you give us a few more that work for you?',
  ERROR: 'Error Detected',
};

export const STATUS_CARD_SUBTEXTS = {
  STAND_BY: 'We weren’t able to find any technicians for your exact times.',
};

export const PANEL_GROUP = {
  PROD_SHIPMENT: 'prodShipment',
  ORDER_STATUS: 'orderStatus',
  ORDER_SUMMARY: 'orderSummary',
};

export const PANEL_GROUP_ORDER = {
  AUTH_ERROR: [PANEL_GROUP.ORDER_STATUS, PANEL_GROUP.PROD_SHIPMENT, PANEL_GROUP.ORDER_SUMMARY],
  DEFAULT: [PANEL_GROUP.PROD_SHIPMENT, PANEL_GROUP.ORDER_STATUS, PANEL_GROUP.ORDER_SUMMARY],
};
